module.exports = __webpack_public_path__ + "media/images/default/join_us/assistant-24ac9776e8ec5b93f87d2d00478da7ca.jpg";